import DOM from '@common/DOM/DOM'

/** Eltűnteti a töltőképernyőt, ha van. */
export default function removeWorkingScreen (): void {
  const black = document.querySelector('.working-screen__black')

  DOM.remove(black)
}
